import React from 'react';

import { GetHeaderMenuItemsResponse } from '../../Api/SiteApi/Responses';
import BalanceElement from '../user/user-panel/BalanceElement.lazy';

interface Props {
    menuItems: GetHeaderMenuItemsResponse[];
    isGuest: boolean;
    onClose: () => void;
}

const HeaderMenu = ({ menuItems, isGuest, onClose }: Props) => {
    const handleClick = (url: string) => {
        window.location.href = url;
    };

    return (
        <div id="header-dropdown" className="dropdown-menu">
            <ul className="navbar">
                {!isGuest && (
                    <div className="header d-flex w-100">
                        <div className="balance d-flex flex-column">
                            <span className="nav-link balance">Your balance</span>
                            <div className="nav-link amount">
                                <BalanceElement />
                            </div>
                        </div>
                        <button className="deposit btn btn-primary">Deposit</button>
                        <button className="close" onClick={onClose}>
                            <i className="fas fa-times" />
                        </button>
                    </div>
                )}

                {isGuest && (
                    <div className="header d-flex justify-content-between w-100">
                        <div className="auth-buttons d-flex">
                            <button className="login btn btn-primary">Log In</button>
                            <button className="register btn btn-primary">Register</button>
                        </div>
                        <button className="close" onClick={onClose}>
                            <i className="fas fa-times" />
                        </button>
                    </div>
                )}
                {menuItems.map((item, i) => (
                    <li key={i} className="nav-item">
                        <button onClick={() => handleClick(item.url)} className="menu-link">
                            {item.name}
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default HeaderMenu;
